var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var TaskContainer = function (_a) {
    var children = _a.children;
    return (_jsx("div", __assign({ className: "panel dskb" }, { children: _jsx("div", __assign({ className: "panel-body" }, { children: _jsx("table", __assign({ className: "dskb-container" }, { children: _jsx("tbody", { children: _jsx("tr", { children: _jsx("td", { children: children }) }) }) })) })) })));
};
export default TaskContainer;
